import { Icon } from '#components/Icon'
import WarningIcon from '#icons/warning-triangle-outline-16.svg'
import type { TruckConfiguration } from '#store/slices/configurationSlice'
import { useDenominationDisplayData } from './useDenominationDisplayData'

export const DenominationAndPartPeriod = ({ configuration }: { configuration: TruckConfiguration | undefined }) => {
  const { marketDenomination, displayPartPeriod, partPeriodWarning } = useDenominationDisplayData(configuration)

  return (
    <div className="_denomination">
      <span className="_denomination">{marketDenomination}</span>
      <span className="_part-period">
        {displayPartPeriod}
        {partPeriodWarning && <Icon iconUrl={WarningIcon} size="xxs" title={partPeriodWarning} />}
      </span>
    </div>
  )
}
